import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStarFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M12,10.232c-3.506,0-5.862,2.777-5.862,6.91,0,1.389,.354,2.297,1.084,2.777,1.077,.709,2.43,.125,3.516-.344,.431-.187,1.022-.441,1.262-.441s.838,.24,1.262,.441c2.296,1.09,3.155,.581,3.516,.344,.729-.479,1.084-1.388,1.084-2.777,0-4.133-2.356-6.91-5.862-6.91Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M20.271,8.65c-1.245,0-2.728,.515-2.728,2.965s1.483,2.966,2.728,2.966,2.729-.515,2.729-2.966-1.484-2.965-2.729-2.965Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M3.729,8.65c-1.245,0-2.729,.515-2.729,2.965s1.484,2.966,2.729,2.966,2.728-.515,2.728-2.966-1.483-2.965-2.728-2.965Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M15.24,9.681c1.245,0,2.729-.515,2.729-2.965s-1.484-2.966-2.729-2.966-2.728,.515-2.728,2.966,1.483,2.965,2.728,2.965Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M8.76,9.681c1.245,0,2.728-.515,2.728-2.965s-1.483-2.966-2.728-2.966-2.729,.515-2.729,2.966,1.484,2.965,2.729,2.965Z" })
	]
});
export default SvgStarFill;
